
import layoutMixins from '@/mixins/events'
import CookieGDPRMixins from '@/mixins/gdpr'
import HeaderNavbar from '@/components/header'
import Dock from '@/components/dock'
import FooterNavbar from '@/components/footer'
import CookieTerms from '@/components/cookie'

export default {
  name: 'JafunApp',

  components: {
    HeaderNavbar,
    Dock,
    FooterNavbar,
    CookieTerms,
  },
  mixins: [layoutMixins, CookieGDPRMixins],

  data() {
    return {
      modal_open: false,
      menu_collapsed: false,
      header: {
        fixed: false,
        transparent: false,
        collapsed: true,
      },
      dock: {
        active: true,
      },
    }
  },
}
